<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="1000">
      <custom-modal
        title="Shop to shop stock transfer "
        @onSubmit="saveBatch"
        @onClose="cancelBatch"
        :isLoading="isLoading"
      >
        <v-data-table
          :fixed-header="true"
          :headers="columns"
          :items="productDetails"
          item-key="id"
          disable-pagination
          hide-default-footer
          class="row-pointer product-list"
          expand
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <strong>From: </strong
              ><v-chip class="ml-4" label>{{
                productDetails[0].productDetail.shop.name
              }}</v-chip>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-autocomplete
                item-text="name"
                item-value="id"
                :items="assingShops"
                label="To"
                :error-messages="productDetailSHoperror"
                v-model="toShop.to_shop_id"
                @input="productDetailSHoperror = []"
                outlined
                :search-input.sync="searchShop"
              >
              </v-autocomplete>
            </v-toolbar>
          </template>
          <template v-slot:item.available="{ item }">
            <v-text-field
              v-model="item.productDetail.quantity"
              :error-messages="item.productDetail.quantityMaxErrorMessages"
              @input="checkQuantityMaximum(item)"
              :max="item.productDetail.maxStock"
              type="number"
              label="Quantity"
              required
              v-bind="attrs"
              v-on="on"
              dense
              class="pt-3"
              outlined
              min="0"
            ></v-text-field>
          </template>
        </v-data-table>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from '@/plugins/axios';
import datePickComponent from '@/components/base/DateComponent';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import * as moment from 'moment/moment';

export default {
  data: () => ({
    toShop: {
      to_shop_id: null,
    },
    query: '',
    searchShop: null,
    productDetailSHoperror: [],
    shopLoading: false,
    columns: [
      {
        text: 'Product Name',
        value: 'productDetail.product.name',
        show: true,
        disabled: true,
        align: 'left',
        width: '14.2%',
      },
      {
        text: 'Batch Name',
        value: 'details.batch.batch',
        show: true,
        disabled: true,
        align: 'left',
        width: '14.2%',
      },
      {
        text: 'Unit',
        value: 'productDetail.unit.name',
        align: 'left',
        show: true,
        disabled: false,
        width: '14.2%',
      },
      {
        text: 'quantity',
        value: 'available',
        show: true,
        disabled: false,
        align: 'center',
        width: '14.2%',
      },
    ],
    dialog: false,
    show: false,

    isLoading: false,
  }),

  name: 'AddBatch',
  updated: function () {},
  props: {
    productDetails: {
      type: Array,
      default: [],
    },
  },
  components: { ValidationProvider, ValidationObserver, datePickComponent },
  watch: {
    searchShop(value) {
      value ? (this.query = value) : (this.query = '');
      console.log('value =', value);
      this.GetShops();
    },

    productDetails: function () {
      this.GetShops();
    },
  },
  created() {
    this.GetShops();
  },
  methods: {
    GetShops() {
      axios
        .get(
          `products/${this.productDetails[0].productDetail.product.id}/shops?search=${this.query}&page=1&size=15&query=`,
        )
        .then((res) => {
          this.assingShops = res.data.data;
        })
        .catch((err) => {
          this.shopLoading = false;
          this.messages = err.data.name;
        });
    },
    updateBarcode(value) {},
    openModal() {
      this.toShop.to_shop_id = null;
      this.show = true;
    },
    checkQuantityMaximum(item) {
      item.productDetail.quantityMaxErrorMessages = [];
      if (item.productDetail.quantity > item.productDetail.maxStock) {
        item.productDetail.quantityMaxErrorMessages.push(
          `max Quantity is ${item.productDetail.maxStock}`,
        );
      }
    },
    cancelBatch() {
      this.show = false;
      this.$emit('conform', '');
    },
    async checkBarcode(unit) {
      let result = await this.checkBarcodeDuplicate(unit.barcode);
      if (result == true) {
        unit.barcodeError = [];
        unit.barcodeError.push('Duplicate Barcode Found');
      }
    },
    async saveBatch() {
      let error = false;
      if (this.toShop.to_shop_id == null) {
        error = true;
        this.productDetailSHoperror = [];
        this.productDetailSHoperror.push('Shop is required');
      }
      if (
        this.toShop.to_shop_id == this.productDetails[0].productDetail.shop.id
      ) {
        error = true;
        this.productDetailSHoperror = [];
        this.productDetailSHoperror.push('can not be transferred to same shop');
      }

      for (let u of this.productDetails) {
        if (u.productDetail && u.productDetail.quantity <= 0) {
          error = true;
          u.productDetail.quantityMaxErrorMessages = [];
          u.productDetail.quantityMaxErrorMessages.push(
            'quantity should be greater than 0',
          );
        } else if (
          u.productDetail &&
          u.productDetail.quantity > u.productDetail.maxStock
        ) {
          error = true;
        } else {
          u.productDetail.quantityMaxErrorMessages = [];
        }
      }
      if (!error) {
        let Credentials = new Object();
        Credentials.date = moment().format('YYYY-MM-DD');
        Credentials.remarks = 'remarks';
        Credentials.from_shop_id = this.productDetails[0].productDetail.shop.id;
        Credentials.to_shop_id = this.toShop.to_shop_id;
        Credentials.items = [];
        this.productDetails.map((p) => {
          let item = new Object();
          item.product_id = p.productDetail.product.id;
          item.batch_id = p.details.batch.id;
          item.unit_id = p.productDetail.unit.id;
          item.quantity = p.productDetail.quantity;
          Credentials.items.push(item);
        });
        this.isLoading = true;
        this.$store
          .dispatch('product/ShopToShopTransfer', Credentials)
          .then((res) => {
            this.isLoading = false;
            this.$toast.success('Product transfered successfully');
            this.$emit('saved', true);
            this.show = false;
          })
          .catch((err) => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
